/* eslint-disable */
/* eslint-disable prefer-template */
import { injectIntl } from 'react-intl';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from '../../../components/Box';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { normalizeSearchString } from '../../../utils/normalizeSearchString';
import { Cell, List, Row } from '../../../components/List';
import { changeVehicleFilter, vehicleSearch } from '../actions';
import { selectAddressTypes } from '../../Address/selectors';
import { Button } from '../../../components/Buttons';
import { Car } from '../../../components/Icon';
import { parseCompany } from '../../Companies/helpers';
import { Modal } from '../../../components/Modal';
import { selectWork } from '../../Api/selectors';
import { REQUEST_VEHICLES } from '../constants';
import { Loader } from '../../../components/Loader';
import { formatLicensePlate } from '../../../utils/string';
import { parseVehicle } from '../helpers';

import ButtonComponent from '../../../containers/App/Components/Button/Button';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import styles from './VehicleSelectionModalButton.module.css';

const STATE = {
  string: '',
  active: false,
};

const Container = styled.div`
  .form-controlField,
  .form-controlField > div {
    width: 100%;
  }
  .results {
    max-height: 60vh;
    overflow-y: auto;
    width: 100%;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class VehicleSelectionModalButtonComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  reset() {
    this.setState({ ...STATE });
  }

  getHomeAddressCity(company) {
    const addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0]?.id;
    return company?.addresses?.filter(a => a?.typeId == addressTypeId)[0]?.city;
  }

  onStringChange(evt) {
    let string = evt.target.value;
    this.setState({ string });
  }

  search = () => {
    const string = normalizeSearchString(this.state.string);
    this.props.search(string, result => {
      this.setState({
        result: result.items?.map(parseVehicle),
      });
    });
  };

  render() {
    return (
      <Container>
        {this.renderModal()}
        <ButtonComponent size={'btn-sm'} style={'ButtonSoftPrimary'} onClick={this.setStateFn({ active: true })}>
          <Car />
        </ButtonComponent>
      </Container>
    );
  }

  renderModal() {
    if (!this.state.active) return null;
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('vehicle.search.placeholder')}>
        <div className={styles.container}>
          <label className="form-label">{this.props.label || null}</label>
          <div className="d-flex gap-2 align-items-center">
            <input
              className="form-control"
              name="string"
              onChange={this.onStringChange.bind(this)}
              value={this.state.string}
              placeholder={`${this.lblStr('vehicle.search.placeholder')}...`}
            />
            <div className={styles.button}>
              <ButtonComponent size={'btn-sm'} style={'ButtonSoftEdit'} onClick={this.search}>
                {this.lblStr('zoeken')}
              </ButtonComponent>
            </div>
          </div>

          {this.props.work ? <Loader small /> : this.renderResult()}
        </div>
      </ModalComponent>
    );
  }

  renderResult() {
    if (!this.state.result) return '';
    return (
      <div className="results">
        <List className={styles.listItem}>
          {this.state.result.map(vehicle => (
            <Row
              className={styles.rowContainer}
              key={vehicle.id}
              onClick={() => {
                this.setState({ result: null });
                if (this.props.onSelect) this.props.onSelect(vehicle);
              }}
            >
              <Cell className={styles.cell1}>
                <span style={{ fontWeight: 400, opacity: '0.6' }}>{vehicle.id}</span>
              </Cell>
              <Cell className={styles.cell2}>{formatLicensePlate(vehicle.regplate)}</Cell>
              <Cell className={styles.cell3}>{vehicle.vin}</Cell>
            </Row>
          ))}
        </List>
      </div>
    );
  }
}

VehicleSelectionModalButtonComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLES),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    search(string, callback) {
      dispatch(vehicleSearch(string, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleSelectionModalButton = compose(withConnect, withRouter, injectIntl)(VehicleSelectionModalButtonComp);
